import { createSlice } from "@reduxjs/toolkit";

const playlistSlice = createSlice({
    name: "playlist",
    initialState: {
        shuffleList: []
    },
    reducers: {
        getPlaylistNextTrackId: (state, action) => {

            const tracks = action.payload;
            if (!Array.isArray(tracks) || tracks.length === 0) return null;

            // Filter valid items
            const filteredItems = tracks.filter(
                (item) =>
                    item.type !== "sounds" ||
                    item.category === 164 ||
                    item.category === 163
            );

            if (filteredItems.length === 0) return null;

            // Skip the first track (index 0 auto plays)
            if (state.shuffleList.length === 0) {
                state.shuffleList.push(filteredItems[0].id);
                console.log(state.shuffleList)
                return filteredItems[0].id;
            }

            // Stop when all have been played
            if (state.shuffleList.length >= filteredItems.length) {
                console.log("All tracks played in shuffle mode");
                return null;
            }

            // Filter out already played tracks
            const available = filteredItems.filter((item) => !state.shuffleList.includes(item.id));

            // Pick random track
            const randomItem = available[Math.floor(Math.random() * available.length)];

            state.shuffleList.push(randomItem.id);

            console.log(state.shuffleList)

            return randomItem.id;
        },
        setPlaylistTrackId: (state, action) => {
            state.shuffleList.push(action.payload)
        },
    },
});

export default playlistSlice.reducer;

export const { setPlaylistTrackId, getPlaylistNextTrackId } = playlistSlice.actions;
